// extracted by mini-css-extract-plugin
module.exports = {"mySwal":"utils_mySwal__3XBKB","confirmButton":"utils_confirmButton__1hfd1"};